import * as React from 'react';
import { getOnBoardCredit } from '../helpers/priceHelpers';
import { __ } from '../helpers/TranslationService';
import { ICruiseReducer } from '../interfaces';
import { IRequestFormReducer } from '../interfaces/IRequestForm';
import * as vars from '../consts/variables';
import { GiftIcon } from '../components/Icons/GiftIcon';
import { WarningIcon } from '../components/Icons/newIcons/WarningIcon';

const styles: Record<string, React.CSSProperties> = {
    stockPriceWrapper: {
        paddingRight: '12px',
        background: vars.softRed4,
        border: 'solid 1px',
        borderColor: vars.softRed20,
        borderRadius: '6px',
        position: 'relative',
        overflow: 'hidden',
        height: '38px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    onBoardCreditWrapper: {
        margin: '15px 15px 0',
        padding: '10px',
        position: 'relative',
        overflow: 'hidden',
        height: '38px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: vars.softBlue4,
        border: 'solid 2px',
        borderColor: vars.softBlue20,
        borderRadius: '6px',
    },
    giftIcon: {
        fill: vars.softBlue,
        marginRight: '7px',
        verticalAlign: 'middle',
    },
    warningIcon: {
        fill: vars.softRed,
        marginRight: '7px',
        verticalAlign: 'middle',
    },
    text: {
        color: vars.softBlack,
        fontSize: 14,
        textAlign: 'center',
        fontWeight: 'bold',
    },

    gift: {
        position: 'absolute',
        left: '4px',
        height: '20px',
        width: '20px',
    },
};

interface IProps {
    cruisePage: ICruiseReducer;
    stockThreshold: any;
    countryCode: string;
    wrapperStyle?: any;
    innerStyle?: any;
    requestForm?: IRequestFormReducer;
    isRequestForm?: boolean;
    isDreamlinesPackage?: boolean;
    background?: string;
    isAllInclusiveSelected?: boolean;
    OBCBlacklist?: number[];
}
export const getStockPrice = (props) => {
    let stock = 0;
    const selectedSail = props.cruisePage.sails[props.cruisePage.selectedSailIndex];
    if (
        selectedSail &&
        props.stockThreshold &&
        props.stockThreshold.cabinAvailabilityMaxThreshold
    ) {
        const shipsThreshold = props.stockThreshold.ships
            ? props.stockThreshold.ships.filter(
                  (item) => item.shipNid === props.cruisePage.ship.nid,
              )
            : false;
        const shipThreshold = shipsThreshold?.length
            ? shipsThreshold.reduce(
                  (min, curr) => (min < curr.urgencyLimit ? curr.urgencyLimit : min),
                  shipsThreshold[0].urgencyLimit,
              )
            : false;

        let currThreshold = props.stockThreshold.cabinAvailabilityMaxThreshold;

        if (shipThreshold && shipThreshold < currThreshold) {
            currThreshold = shipThreshold;
        }

        const selectedSailNid = selectedSail.nid;

        const currentRates = props.cruisePage.rates.filter(
            (item) => selectedSailNid === item.sail_nid,
        );

        stock = currentRates.reduce((acc: any, curr: any) => acc + curr.stock, 0);

        if (stock <= 0 || stock > currThreshold) {
            return null;
        }
        return stock;
    } else {
        return null;
    }
};

export function Urgency(props: IProps) {
    const stockPrice = getStockPrice(props);
    const onBoardCredit = getOnBoardCredit(
        props.cruisePage?.company.nid,
        props.requestForm?.perPersonPrice,
        props.cruisePage?.rates,
        props.isAllInclusiveSelected,
        props.OBCBlacklist,
    );
    if (!stockPrice && !onBoardCredit) {
        return null;
    }
    return (
        <div
            style={{
                padding: stockPrice ? '17px 15px 0' : 0,
                backgroundColor: props.background || 'inherit',
            }}
        >
            {!!stockPrice && (
                <div id="stockPriceBanner" style={styles.stockPriceWrapper}>
                    <div style={styles.icon}>
                        <WarningIcon width={20} height={20} style={styles.warningIcon} />
                    </div>
                    <span style={styles.text}>
                        {__('Only %s cabins available', 'dreamlines', stockPrice)}
                    </span>
                </div>
            )}

            {!!onBoardCredit && !props.isDreamlinesPackage && props.countryCode === 'de' && (
                <div style={styles.onBoardCreditWrapper}>
                    <div style={styles.icon}>
                        <GiftIcon width={20} height={20} style={styles.giftIcon} />
                    </div>
                    <span style={{ ...styles.text, color: vars.softBlack }}>
                        {!props.isRequestForm && `${__('up to', 'dreamlines')} `}
                        {__('%s $ onboard credit', 'dreamlines', onBoardCredit)}
                    </span>
                </div>
            )}
        </div>
    );
}
